<div class="admin-bar">Admin</div>
<app-menu></app-menu>
<app-login-validation (loggedIn)="onLoginValidated($event)"></app-login-validation>

<div class="page">
  <div class="container">
    <div class="header-row">
      <h1>Permissões por Usuário</h1>
      <button mat-raised-button class="btn-primary button-login" (click)="newUser()" aria-label="Novo usuário">
        <mat-icon>person_add</mat-icon>
        Novo usuário
      </button>
    </div>

    <ng-container *ngIf="isLoading; else listTpl">
      <div class="spinner">
        <mat-progress-spinner mode="indeterminate" diameter="56"></mat-progress-spinner>
      </div>
    </ng-container>

    <ng-template #listTpl>
      <!-- Cabeçalho -->
      <div class="list-header">
        <div class="col user">Usuário</div>
        <div class="col email">E-mail</div>
        <div class="col active">Ativo</div>
        <div class="col perms">Permissões</div>
        <div class="col date">Incluído em</div>
        <div class="col actions">Ações</div>
      </div>

      <!-- Linhas -->
      <div class="row" *ngFor="let u of list; trackBy: trackByUser">
        <div class="col user">
          <div class="title-text">{{ u.userName || '—' }}</div>
        </div>
        <div class="col email">{{ u.userEmail || '—' }}</div>
        <div class="col active">
          <span class="chip" [ngClass]="u.isActive ? 'chip-on' : 'chip-off'">
            {{ u.isActive ? 'Ativo' : 'Inativo' }}
          </span>
        </div>
        <div class="col perms">
          <span class="perm-pill" [matTooltip]="permTooltip(u)">
            {{ (u.listUserPermission?.length || 0) }} permissões
          </span>
        </div>
        <div class="col date">
          {{ (u.datetimeInclusion || '') | date:'dd/MM/yyyy HH:mm' }}
        </div>
        <div class="col actions">
          <button mat-icon-button
                  [matTooltip]="'Editar permissões'"
                  aria-label="Editar permissões"
                  (click)="editUserPermissions(u.idUser)">
            <mat-icon style="color:#0c720c;">shield</mat-icon>
          </button>

          <button mat-icon-button
                  [matTooltip]="'Excluir todas as permissões do usuário'"
                  aria-label="Excluir permissões"
                  (click)="deleteAll(u.idUser, u.userName)">
            <mat-icon style="color:#8d2b2b;">delete</mat-icon>
          </button>
        </div>
      </div>

      <div *ngIf="!list?.length" class="empty">
        Nenhum usuário com permissões encontrado.
      </div>
    </ng-template>
  </div>
</div>

<app-footer></app-footer>
